export const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export const MONTH_OPTIONS = [
  { value: "all", label: "Any Month" },
  ...MONTHS.map((m, i) => ({ value: String(i + 1), label: m })),
];
